const dateFmt = new Intl.DateTimeFormat("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
const euroFmt = new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", useGrouping: "always" });

export const formatDate = (value) => (value ? dateFmt.format(new Date(value)) : "—");

export const formatEuro = (value) => euroFmt.format(Number(value || 0));

export const formatDay = (iso) => (iso ? iso.slice(0, 10).split("-").reverse().join("/") : "");

export const longDate = (d = new Date()) =>
  new Intl.DateTimeFormat("it-IT", { weekday: "long", day: "numeric", month: "long", year: "numeric" }).format(d);

export const timeHM = (d = new Date()) =>
  new Intl.DateTimeFormat("it-IT", { hour: "2-digit", minute: "2-digit" }).format(d);

export const initials = (name = "") =>
  name.split(" ").filter(Boolean).slice(0, 2).map((p) => p[0].toUpperCase()).join("") || "U";
